import wx from 'weixin-js-sdk'

export function wxShares(res, shareConfig) {
  console.log(res)
  wx.config(res)
  // wx.config({
  //   debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  //   appId: res.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
  //   timestamp: res.timestamp, // 必填，生成签名的时间戳
  //   nonceStr: res.nonceStr, // 必填，生成签名的随机串
  //   signature: res.signature,// 必填，签名
  //   jsApiList: res.jsApiList
  // })
  // res.debug = true
  wx.ready(function () {
    const share = {
      title: shareConfig.title || '云游2023工博会',
      desc: shareConfig.desc || '数字赋能，加速迈向可持续的未来工业',
      imgUrl: shareConfig.imgUrl || 'https://events.schneider-electric.cn/ciif2023/Api/img/share.png',
      link: shareConfig.link,
      success: function () {
        // 分享成功，成功之后要做的事情
      },
      cancel: function () {
        // 分享取消，取消之后要做的事情
      },
    }
    // wx.updateAppMessageShareData(share)
    // wx.updateTimelineShareData(share)
    wx.onMenuShareAppMessage(share) // 微信好友
    wx.onMenuShareTimeline(share) // 朋友圈
    wx.onMenuShareQQ(share) // QQ
    wx.onMenuShareQZone(share) // QQ空间
    wx.onMenuShareWeibo(share) // 腾讯微博
  })
}

